<template>
  <div class="max-w-6xl my-16 relative">
    <div :style="wrapperStyle">
      <iframe class="absolute top-0 left-0" :src="row.url" />
      <figcaption v-if="blockCaption" v-html="blockCaption" class="absolute max-w-6xl mx-auto text-xs mt-2 mb-6 flex-1 mb-16"></figcaption>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseIframeRow',
  props: {
    row: Object
  },
  computed: {
    wrapperStyle () {
      const ratio = this.row.height / this.row.width * 100
      return {
        width: '100%',
        'padding-top': `${ratio}%`
      }
    },
    blockCaption () {
      const c = this.row.caption
      if (!c) return false
      return c.length > 0 && c
    }
  }
}
</script>

<style lang="stylus" scoped>
  iframe
    width: 100%
    height: 100%
</style>
